import React from 'react';
import {createBottomTabNavigator} from '@react-navigation/bottom-tabs';
import {ITheme, useTheme} from 'contexts/ThemeContext';
import {Image, Platform} from 'react-native';
import {Screens, Flows, ScreenName} from './Screens';
import HomeFlow from './HomeFlow';
import AnalyticsFlow from './AnalyticsFlow';
import strings from 'translations';
import ProfileFlow from './ProfileFlow';
import AdminFlow from './AdminFlow';
import GroupsFlow from './GroupsFlow';
import ChartsScreen from 'screens/charts';
import TranscriptionsScreen from 'screens/transcriptions';

export const createTabBarScreens = (theme: ITheme) => [
  {
    name: Flows.homeFlow,
    component: HomeFlow,
    tabTitle: strings.tabbar.classes,
    activeIcon: theme.images.homeTabActive,
    inactiveIcon: theme.images.homeTabInactive,
  },
  {
    name: Flows.analyticsFlow,
    component: AnalyticsFlow,
    tabTitle: strings.tabbar.analytics,
    activeIcon: theme.images.chartsTabActive,
    inactiveIcon: theme.images.chartsTabInactive,
  },
  {
    name: Flows.profileFlow,
    component: ProfileFlow,
    tabTitle: strings.tabbar.profile,
    activeIcon: theme.images.profileTabActive,
    inactiveIcon: theme.images.profileTabInactive,
  },
];

export const createAdminScreens = (theme: ITheme) => [
  {
    name: Flows.adminPanelGeneralFlow,
    component: AdminFlow,
    tabTitle: strings.tabbar.classes,
    activeIcon: theme.images.homeTabActive,
    inactiveIcon: theme.images.homeTabInactive,
  },
  {
    name: Flows.adminPanelGroupsFlow,
    component: GroupsFlow,
    tabTitle: strings.tabbar.analytics,
    activeIcon: theme.images.chartsTabActive,
    inactiveIcon: theme.images.chartsTabInactive,
  },
];

export const createAnalyticsScreens = (theme: ITheme) => [
  {
    name: ScreenName.charts,
    component: ChartsScreen,
    tabTitle: strings.analyticsScreen.charts,
    activeIcon: theme.images.homeTabActive,
    inactiveIcon: theme.images.homeTabInactive,
  },
  {
    name: ScreenName.transcriptions,
    component: TranscriptionsScreen,
    tabTitle: strings.analyticsScreen.transcriptions,
    activeIcon: theme.images.chartsTabActive,
    inactiveIcon: theme.images.chartsTabInactive,
  },
];

export const createNavigationHeaderWebScreens = (
  isAdmin: boolean,
  theme: ITheme,
) => {
  const navigationStack = [
    {
      name: Flows.homeFlow,
      tabTitle: strings.tabbar.classes,
    },
    {
      name: Flows.analyticsFlow,
      tabTitle: strings.tabbar.analytics,
    },
  ];

  if (isAdmin) {
    navigationStack.push({
      name: Flows.adminPanelGeneralFlow,
      tabTitle: strings.tabbar.adminPanel,
    });
  }

  return navigationStack;
};

export const createNavigationAdmin = (theme: ITheme) => {
  const navigationStack = [
    {
      name: Screens.AdminPanelGeneralScreen.name,
      tabTitle: strings.adminPanelTabbar.general,
    },
    {
      name: Screens.AdminPanelTeachersScreen.name,
      tabTitle: strings.adminPanelTabbar.teachers,
    },
    {
      name: Flows.adminPanelGroupsFlow,
      tabTitle: strings.adminPanelTabbar.groups,
    },
  ];

  return navigationStack;
};

export const createNavigationAnalyticsInfo = (theme: ITheme) => {
  const navigationStack = [
    {
      name: Screens.ChartsScreen.name,
      tabTitle: strings.analyticsScreen.charts,
    },
    {
      name: Screens.TranscriptionsScreen.name,
      tabTitle: strings.analyticsScreen.transcriptions,
    },
  ];

  return navigationStack;
};
const Tab = createBottomTabNavigator();

const TabBar = () => {
  const theme = useTheme();

  const tabbarScreens = createTabBarScreens(theme);
  const adminScreens = createAdminScreens(theme);
  const analyticsScreens = createAnalyticsScreens(theme);

  return (
    <Tab.Navigator
      initialRouteName={Flows.homeFlow}
      screenOptions={({route}) => ({
        tabBarStyle: {
          display: 'none',
        },
        tabBarIcon: ({focused}) => {
          let iconName;

          if (route.name === Flows.homeFlow) {
            iconName = focused
              ? theme.images.homeTabActive
              : theme.images.homeTabInactive;
          } else if (route.name === Flows.analyticsFlow) {
            iconName = focused
              ? theme.images.chartsTabActive
              : theme.images.chartsTabInactive;
          } else if (route.name === Screens.ProfileScreen.name) {
            iconName = focused
              ? theme.images.profileTabActive
              : theme.images.profileTabInactive;
          }
          return <Image source={iconName} />;
        },
      })}>
      {tabbarScreens.map((screen, index) => {
        return (
          <Tab.Screen
            key={index}
            name={screen.name}
            component={screen.component}
            options={{
              headerShown: false,
            }}
          />
        );
      })}
      {Platform.OS == 'web' &&
        adminScreens.map((screen, index) => {
          return (
            <Tab.Screen
              key={index}
              name={screen.name}
              component={screen.component}
              options={{
                headerShown: false,
              }}
            />
          );
        })}
        {Platform.OS == 'web' &&
        analyticsScreens.map((screen, index) => {
          return (
            <Tab.Screen
              key={index}
              name={screen.name}
              component={screen.component}
              options={{
                headerShown: false,
              }}
            />
          );
        })}
    </Tab.Navigator>
  );
};

export default TabBar;
